import React from 'react'
import PropTypes from 'prop-types'
import { Button } from './..'
import { Chevron } from '../Svg'

import styles from './OverlayPanelHeader.module.scss'

const OverlayPanelHeader = ({ onBack, children }) => (
  <div className={styles.header}>
    <div className={styles.backButtonWrap}>
      <Button iconStart={Chevron} onClick={onBack} minimal>
        Back
      </Button>
    </div>
    <div className={styles.headerContent}>{children}</div>

    {/* Used for centering the header at all times */}
    <div className={styles.empty} />
  </div>
)

OverlayPanelHeader.propTypes = {
  onBack: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

export default OverlayPanelHeader
